import store from "@/store";

export default function authHeader() {
  const auth = store.getters["auth/token"];
  if (auth) {
    return {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
      "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
      Authorization: `Bearer ${store.getters["auth/token"]}`,
      "Content-Type": "application/json",
    };
  } else {
    return {};
  }
}
